<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>
      Podgorica and its surroundings (through the centuries and today)
    </h1>
    <div class='tourPic'>
      <img src='@/assets/cultours/tour2/02.jpg' />
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDescription'
            ><h4 class='titles'>Tour description</h4></a
          >
          <div class='collapse' id='tourDescription'>
            <p class='pasus'>
              With this 4-5 hours long tour we intend to introduce you to the
              most important cultural and historical heritage of the Capital
              City: the remains of millenniums old Illyrian and Roman
              settlements, the monumental heritage from socialist period,
              churches from both medieval and modern age, the fortress and the
              old town dating back to Ottoman period as well as with famous city
              locations and details of modern Podgorica. Finally, in the city of
              wine, it would be a pity not to visit one of the well-known small
              city wineries.
            </p>
            <p class='pasus'>
              Well-positioned, the area of today’s Podgorica was definitely
              inhabited as early as in prehistoric times but the historically
              confirmed remains of the first settlements date back to 3rd and
              4th century BC. This tour will tell you the story starting right
              from that period of history.
            </p>
            <p class='pasus'>
              The tour is designed as a combination of walking and driving so
              that we can have the best look into everything planned within the
              tour. The first part of the tour, in the morning hours, would
              comprise walking and getting to know the main city attractions
              covering the period of modern times and part of inheritance from
              Ottoman period and a visit to a magnificent city temple. We would
              then continue exploring the town’s surroundings, the remains of
              Roman town of Doclea and the Illyrian fortress Meteon from 3rd
              century BC and end it with a visit to a local winery.
            </p>
            <p class='pasus'>
              A visit to the museum of Marko Miljanov, a celebrated Montenegrin
              warrior, writer and philosopher, where we will get to know his
              character and work but also the folklore elements of Montenegro,
              would be a memorable experience.
            </p>
            <p class='pasus'>
              While on this tour we will have a chance to enjoy the view from
              one of the nearby lookouts, to take a ride down the slopes of Kuci
              Mountain Massif and we surely won’t miss the opportunity to dip
              our hands into clear waters of one of the five Podgorica rivers.
            </p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#tourDetails'
            ><h4 class='titles'>Tour details</h4></a
          >
          <div class='collapse' id='tourDetails'>
            <p class='pasus'>Type of tour: Private</p>
            <p class='pasus'>Availability: All year round</p>
            <p class='pasus'>Group size: 1-7</p>
            <p class='pasus'>Departure from: Podgorica</p>
            <p class='pasus'>Difficulty level: easy/moderate</p>
            <p class='pasus'>Duration: 4-5 h</p>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <h4 class='titles'>Highlights</h4>
          <vue-picture-swipe :items='items'></vue-picture-swipe>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#itinerary'
            ><h4 class='titles'>Itinerary</h4></a
          >
          <div class='collapse' id='itinerary'>
            <ul class='square'>
              <li class='pasus'>
                8:30 a.m. - a pick up at your place of stay or at the place we
                agree upon.
              </li>
              <li class='pasus'>
                We begin our walk the very city center and in the next couple of
                hours we get to know the major city attractions.
              </li>
              <li class='pasus'>
                We continue our tour by car to arrive at the city temple the
                interior of which is worth seeing.
              </li>
              <li class='pasus'>
                The tour takes us further to the remains of antic town of Doclea
                where we spend some half an hour to then set out to visit the
                remains of Illyrian town Meteon located some 10 km away from the
                city, in the rural area on the slopes of Kuci Mountain. After an
                easy walk to the top of the hill we will pay a half an hour
                visit to Marko Miljanov museum.
              </li>
              <li class='pasus'>
                Little after noon, if you wish so, we can visit a local winery
                and taste the famous Montenegin wine Vranac.
              </li>
            </ul>
             <div class='tour-time'>
              <p> <i class='fas fa-clock'></i> 50 min</p>
              <p> <i class='fas fa-route'></i> 30 km</p>
            </div>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#prices'
            ><h4 class='titles'>Prices:</h4></a
          >
          <div class='collapse' id='prices'>
            <ul class='square'>
              <li class='pasus'>1 person – 120 EUR</li>
              <li class='pasus'>2 persons – 70 EUR p/person</li>
              <li class='pasus'>3 persons – 50 EUR p/person</li>
              <li class='pasus'>4 persons – 45 EUR p/person</li>
              <li class='pasus'>5 persons - 60 EUR p/person</li>
              <li class='pasus'>6 persons – 55 EUR p/person</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#included'
            ><h4 class='titles'>Included in price:</h4></a
          >
          <div class='collapse' id='included'>
            <ul class='square'>
              <li class='pasus'>Driving by car/van</li>
              <li class='pasus'>Bottle of water</li>
              <li class='pasus'>Entrance fee for museum</li>
              <li class='pasus'>Professional guiding service- English</li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#info'
            ><h4 class='titles'>Practical info:</h4></a
          >
          <div class='collapse' id='info'>
            <ul class='square'>
              <li class='pasus'>
                We recommend purchasing authentic local souvenirs and wines
                produced by small local wineries.
              </li>
              <li class='pasus'>
                Prices of food and beverage in local restaurants are affordable.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <span class='fa-li'
            ><img src='@/assets/logo/lovcen-green.png'
          /></span>
          <a data-toggle='collapse' href='#optional'
            ><h4 class='titles'>Optional:</h4></a
          >
          <div class='collapse' id='optional'>
            <ul class='square'>
              <li class='pasus'>
                Itinerary changes during the tour as agreed (do not affect the
                price)
              </li>
              <li class='pasus'>Lunch at local restaurant</li>
              <li class='pasus'>Visit to local winery</li>
              <li class='pasus'>
                Visit to another of city attractions with possible price
                correction.
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/cultours/tour2/01.jpg'),
          thumbnail: require('@/assets/cultours/tour2/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/02.jpg'),
          thumbnail: require('@/assets/cultours/tour2/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/03.jpg'),
          thumbnail: require('@/assets/cultours/tour2/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/04.jpg'),
          thumbnail: require('@/assets/cultours/tour2/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/05.jpg'),
          thumbnail: require('@/assets/cultours/tour2/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/06.jpg'),
          thumbnail: require('@/assets/cultours/tour2/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/cultours/tour2/07.jpg'),
          thumbnail: require('@/assets/cultours/tour2/07.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/CT2_Podgorica.vue